module.exports = __webpack_public_path__ + "img/island.d605d7a6.png";